import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NewJobService } from '../app-service/newJob.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { AuthService } from '../app-service/auth.service';
import { SharedService } from '../app-service/shared.service';
import { ConfirmPasswordDialogComponent } from '../confirm-password-dialog/confirm-password-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  showErrorMessage = false;
  loading:any
  isLoggedIn=false
  userErrorMessage = false
  userActivity:any;
   userInactive: Subject<any> = new Subject();
   token=''

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Origin,X-Requested-With,Content-Type,Accept,GET',
      'Access-Control-Allow-Methods': 'GET',
      'Content-Type': 'application/json',
    }),
  };

  constructor(private newJobService: NewJobService,public dialog: MatDialog,
    private authService:AuthService,private sharedService:SharedService,
     private router: Router,private snackBar: MatSnackBar) {}
  
  ngOnInit() {
    localStorage.clear();
    
    
  }
  //this method will call login method from NewJobService and will post data
  OnSubmit(username: any, password: any) {
    this.showErrorMessage = false;
    this.loading = true;
    
    
    this.authService.login(username,password).subscribe(
      
      (result: any) => {
              if (result) {
                console.log(result);
                if (result.access_token) {
                  // localStorage.setItem('userToken', result.access_token);

                   this.token=result.access_token                 
                  this.authService.handleUser(result);                  
                 this.isLoggedIn=true;
                 
                 if(result.PasswordChange.toString().toUpperCase()=="TRUE")
                 {
                  this.getUserData(username)
                 }
                 else if(result.PasswordChange.toString().toUpperCase()=="FALSE"){
                  const dialogRef = this.dialog.open(ConfirmPasswordDialogComponent, {
                    disableClose: true,
                    panelClass: 'app-dialog',
                    data: { username: username}
                  });
                  dialogRef.afterClosed().subscribe((data: any) => {
                    // console.log(data)
                    if (data) { this.ngOnInit(); }
                    if (!data) {
                      this.getUserData(username)
                      
                    }                
            
                  });
                 }
                }
                else {
                  //console.log('No Token');
                }
              }
      },
      (error: HttpErrorResponse) => {
        //console.log(error);        
        this.loading = false;
            if (error.status === 400) {
              //console.log('UnAuthorized user');
              //this.showErrorMessage = true;
              this.snackBar.open(error.error.error_description,'',{
                duration:4000
              });
            }
      }
      );
  }
  
  getUserData(u:any)
  {
    if(this.token!=''){
    this.newJobService.getUserDetails(u).subscribe((res:any)=>{
      //console.log(res);
      if(res.Success)
      {
        localStorage.setItem('userDetails',JSON.stringify(res.Model))
        localStorage.setItem('userPermissions',res.Model.Permission)
        this.sharedService.wwidAndUsername(res.Model);
        this.sharedService.countryandstate(res.Model);  
        this.userErrorMessage = false;  
        localStorage.setItem("showWorkCompleted", "true");
        localStorage.setItem("showWorkInProgress", "false"); 
        this.router.navigate(['/workCompleted']);
      }
      else if (res.Message == "User Not Found")
      {
        localStorage.setItem('userDetails',JSON.stringify(res.Model))
        this.sharedService.wwidAndUsername(res.Model);
        this.loading = false;
        this.userErrorMessage = true;
      }
    
      
    })
  }
}
}
